import request from '@/util/request';

export const getPage = (params, options) =>
  request.get('/api/v4ward/qrCodePayRecord/page', Object.assign({}, options, { params }));

